import { httpClient } from '@/services/client/http-client'
import { TSendContactBody } from '@/types/contact'

export const __cContactService = {
  sendContact: async (body: TSendContactBody) => {
    const response = await httpClient.V2.post(`/contact-form`, body)
    return response
  },
}
